import { Component, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('[ErrorBoundary] Uncaught error:', error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center p-6 bg-background text-foreground">
          <div className="max-w-lg w-full rounded-lg border border-border bg-card p-6 shadow">
            <h1 className="text-xl font-semibold mb-2">Algo deu errado</h1>
            <p className="text-sm text-muted-foreground mb-4">
              Ocorreu um erro inesperado. Tente novamente.
            </p>
            <pre className="text-xs bg-muted p-3 rounded overflow-auto max-h-48 mb-4">
              {this.state.error?.message || 'Erro desconhecido'}
            </pre>
            <div className="flex gap-2">
              <button
                onClick={this.handleReset}
                className="px-4 py-2 rounded bg-primary text-primary-foreground text-sm"
              >
                Tentar novamente
              </button>
              <button
                onClick={() => window.location.reload()}
                className="px-4 py-2 rounded border border-border text-sm"
              >
                Recarregar página
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
